<template>
  <b-card border-variant="secondary"
      text-variant="secondary"
      align="center"
      style="max-width: 40rem;"
      class="mx-auto mb-3">

      <b-card-header header-tag="header" class="p-1 m-1 rounded bg-transparent" role="tab">
        <b-row>
          <b-col class="mr-auto"></b-col>
          <b-col class="mr-auto"></b-col>
          <b-col class="col-sm-auto ml-auto">
            <h4>{{ $t('identity.detailsTable') }}</h4>
          </b-col>
          <b-col class="col-sm-auto mr-auto">
            <b-form-select size="sm" v-model="selected_user_id" :options="options" class="identity-select">
              <template #first>
                <b-form-select-option value="" disabled>{{$t('identity.selectIdentity')}}</b-form-select-option>
              </template>
              <b-form-select-option :value="user.userId" v-for="user in user_list" :key="user.userId">{{user.userName}}</b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col></b-col>
          <b-col class="ml-auto">
            <b-dropdown id="dropdown-1" size="sm" variant="transparent" class="text-secondary" :disabled="!identitiesAreAvailable">
              <template #button-content >
                <b-icon icon="gear-fill" variant="secondary"/>
              </template>
              <b-dropdown-item v-if="this.$store.getters.getSelectedUserStatus === 'ACTIVE'" @click="blockIdentity(true)">{{ $t('identity.block') }}</b-dropdown-item>
              <b-dropdown-item v-if="this.$store.getters.getSelectedUserStatus === 'BLOCKED'" @click="blockIdentity(false)">{{ $t('identity.unblock') }}</b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
      </b-card-header>

      <b-card-body class="mx-auto mb-3">
        <b-row class="justify-content-sm-center">
          <b-spinner :label="$t('generic.loading')" v-if="is_loading"></b-spinner>
        </b-row>
        <b-row v-if="!identitiesAreAvailable" class="justify-content-sm-center text-dark">
          <h6>{{ $t('identity.noIdentities') }}</h6>
        </b-row>
        <IdentityStatusRowItem v-if="identitiesAreAvailable" :title="$t('identity.status')" :data="$store.getters.getSelectedUserStatus"/>
        <UnitDetailRowItem v-if="identitiesAreAvailable" change-type="email" 
          :data="$store.getters.getSelectedUserEmail" :title="$t('generic.email')"
          @changeUnitItem="openChangeItemPage" :editLabel="$t('unitDetails.editEmail')"/>
        <UnitDetailRowItem v-if="identitiesAreAvailable" change-type="phoneNumber" 
          :data="$store.getters.getSelectedUserPhone" :title="$t('generic.phone')"
          @changeUnitItem="openChangeItemPage" :editLabel="$t('unitDetails.editPhone')"/>
      </b-card-body>

    </b-card>
</template>

<script>
import store from "@/store/store"
import router from '@/router/index'
import userApiService from "@/services/userApiService"
import UnitDetailRowItem from "@/components/UnitDetailRowItem"
import IdentityStatusRowItem from "./IdentityStatusRowItem.vue";

export default {
  name: 'IdentityDetails',
  components: {
    UnitDetailRowItem,
    IdentityStatusRowItem
  },
  data () {
    return {
      user_list: [],
      is_loading: true
    }
  },
  computed: {
    identitiesAreAvailable() {
      return !this.is_loading && this.user_list?.length > 0
    },
    selected_user_id: {
      get: function() {
        return this.$store.getters.getSelectedUserId
      },
      set: function(newVal) {
        var user = this.user_list.find(u => u.userId === newVal)
        this.$store.dispatch('setSelectedUser', user)
      }
    }
  },
  mounted () {
    this.getAllUsers()
  },
  methods: {
    getAllUsers(){
      if(!store.getters.getIsLoggedIn) {
        return
      }
      this.is_loading = true
      userApiService.getAllUsers(this.type).then(result => {
        if(result?.content && result.content.length > 0) {
          this.user_list = result.content;
          this.selected_user_id = this.$store.getters.getSelectedUserId ? this.$store.getters.getSelectedUserId : result.content[0].userId
        }
        this.is_loading = false
      })
    },
    openChangeItemPage(e){
      if(e==="phoneNumber"){
        router.push({ name: 'ChangeIdentityDetails', params: {changeRequested: e}})
      }else{
        router.push({ name: 'ChangeIdentityDetails', params: {changeRequested: e}})
      }
    },
    async blockIdentity(setToBlock) {
      try {
        this.is_loading = true
        await userApiService.updateIdentityStatus(this.$store.getters.getSelectedUserId, this.$store.getters.getSelectedUserName, setToBlock)
        await this.getAllUsers()
      } catch(e) {
        this.$bvToast.toast( e.response.data.message, {
          title: this.$t('identity.statusUpdateFailed'),
          autoHideDelay: 10000,
          toaster: "b-toaster-top-center",
          variant: "warning",
          append: false,
          solid: false
        })
      }
      this.is_loading = false
    }
  }
}
</script>

<style>
.identity-select {
  max-width: 13rem;
  min-width: 5rem;
}
</style>